import isFunction from 'lodash/isFunction'
import uniq from 'lodash/uniq'
import { templateVariablePattern } from '@ztechapps/common.utils'

export const useCommunicationTemplateVariableReplace = () => {
  const execute = async (template, data) => {
    // A function variable can mint a link, so it runs once per distinct name, however often the template repeats it.
    const fieldNames = uniq(
      Array.from(template.matchAll(templateVariablePattern), (match: RegExpMatchArray) => match[1])
    )

    const entries = await Promise.all(
      fieldNames.map(async (fieldName: string) => {
        const matchValue = data[fieldName]
        return [fieldName, isFunction(matchValue) ? await matchValue() : matchValue] as const
      })
    )
    const values = Object.fromEntries(entries)

    //return empty string if the match value is undefined so it will not write undefined on the chat message input
    return template.replace(templateVariablePattern, (_match, fieldName) => values[fieldName] ?? '')
  }
  return { execute }
}
